export class UniqMap<K, V> {
  private map: Map<K, V>;

  constructor() {
    this.map = new Map();
  }

  add(key: K, value: V): void {
    if (!key) {
      throw new Error('UniqMap cannot have empty keys');
    }
    if (this.map.has(key)) {
      throw new Error(`UniqMap already has this key: ${key}`);
    }

    this.map.set(key, value);
  }

  get(key: K): V | undefined {
    return this.map.get(key);
  }

  getAll(): Array<[K, V]> {
    return [...this.map.entries()];
  }

  getKeys(): K[] {
    return [...this.map.keys()];
  }
}
